import { Component } from '@theme/component';

/**
 * "Direkt kaufen" (blocks/buy-now-button.liquid): adds the currently selected variant of the
 * product form in the same section to the cart and redirects to checkout.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement} [button]
 *
 * @extends {Component<Refs>}
 */
class BuyNowButtonComponent extends Component {
  /** @type {boolean} */
  #pending = false;

  async buyNow() {
    if (this.#pending) return;

    const form = this.#productForm();
    const variantInput = form?.querySelector('input[name="id"]');
    if (!(form instanceof HTMLFormElement) || !(variantInput instanceof HTMLInputElement)) return;

    const addButton = form.querySelector('[name="add"], .add-to-cart-button');
    if (addButton instanceof HTMLButtonElement && addButton.disabled) return;

    this.#pending = true;
    const { button } = this.refs;
    if (button) button.setAttribute('aria-busy', 'true');

    try {
      const body = new FormData(form);
      if (!body.get('quantity')) body.set('quantity', '1');
      const response = await fetch(this.dataset.cartAddUrl || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
      window.location.href = this.dataset.checkoutUrl || '/checkout';
    } catch (error) {
      console.error('[buy-now-button]', error);
      // Fall back to the regular add-to-cart flow so the customer still gets feedback.
      if (addButton instanceof HTMLButtonElement) addButton.click();
      this.#pending = false;
      if (button) button.removeAttribute('aria-busy');
    }
  }

  #productForm() {
    const section = this.closest('.shopify-section') ?? document;
    return section.querySelector('form[data-type="add-to-cart-form"]');
  }
}

if (!customElements.get('buy-now-button-component')) {
  customElements.define('buy-now-button-component', BuyNowButtonComponent);
}
